var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M29.318 12.376c0-.75-.423-1.414-1.104-1.731l-11.77-5.492a2.91 2.91 0 0 0-2.471 0l-11.77 5.492A1.891 1.891 0 0 0 1.1 12.376c0 .751.422 1.415 1.103 1.732l2.771 1.293v4.268c0 1.402.754 2.708 1.97 3.408l2.26 1.304a12.036 12.036 0 0 0 6.004 1.601c2.077 0 4.153-.534 6.005-1.601l2.261-1.304a3.946 3.946 0 0 0 1.969-3.408v-4.268l2.074-.968v7.469c0 .497.403-.059.9-.059s.9.556.9.059v-9.523l.001-.003zm-5.674 7.294c0 .761-.41 1.469-1.068 1.849l-2.261 1.303a10.257 10.257 0 0 1-10.212.001l-2.26-1.303a2.143 2.143 0 0 1-1.069-1.85v-3.429l7.199 3.359a2.91 2.91 0 0 0 2.471 0l7.199-3.359v3.429zm3.81-7.192-11.77 5.492a1.116 1.116 0 0 1-.95 0l-11.77-5.492a.102.102 0 0 1-.064-.102c0-.07.045-.092.064-.101l11.77-5.492a1.129 1.129 0 0 1 .95 0l11.77 5.492c.02.009.064.03.064.101s-.045.093-.064.102z",
    opacity: 1,
    "data-original": "#6621ba",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M28.986 27.122h-1.138a1.916 1.916 0 0 1-1.914-1.913v-2.293c0-1.056.858-1.914 1.914-1.914h1.138c1.055 0 1.914.858 1.914 1.914v2.293a1.915 1.915 0 0 1-1.914 1.913zm-1.137-4.319a.114.114 0 0 0-.114.113v2.293c0 .063.051.112.114.112h1.138c.063 0 .114-.05.114-.112v-2.293a.113.113 0 0 0-.114-.113z",
    opacity: 1,
    "data-original": "#f98a17",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducations);
export default __webpack_public_path__ + "static/media/educations.3cc5c26b524e8c3c35a581eb032f10b9.svg";
export { ForwardRef as ReactComponent };